import React from 'react'
import LoginLoggedArea from './components/LoginComponent'

const Login: React.FC = () => {
  return <LoginLoggedArea />
}

export default Login
